import { AMPLITUDE_OFF_ENROLMENT, } from '@redbubble/next-amplitude';
import { localStorage } from '@redbubble/persistent-storage';
import React, { createContext, useContext, useEffect, } from 'react';
import { useRudderstackClient } from '../rudderstack';
var AmplitudeExperimentContext = createContext(undefined);
export var AmplitudeExperimentProvider = function (_a) {
    var experiments = _a.experiments, children = _a.children;
    return (React.createElement(AmplitudeExperimentContext.Provider, { value: experiments }, children));
};
function isKnownVariant(value, experimentConfig) {
    return experimentConfig.variants.includes(value);
}
export function useAmplitudeExperiment(experimentConfig) {
    var _a;
    var experiments = useContext(AmplitudeExperimentContext);
    var RudderstackClient = useRudderstackClient().RudderstackClient;
    if (experiments === undefined) {
        throw new Error('AmplitudeExperimentContext used outside of its Provider!');
    }
    var experiment = (_a = experiments[experimentConfig.flagKey]) === null || _a === void 0 ? void 0 : _a.enrolment;
    var knownVariant = experiment && isKnownVariant(experiment, experimentConfig)
        ? experiment
        : false;
    useEffect(function () {
        if (!knownVariant || !RudderstackClient)
            return;
        var flagKey = experimentConfig.flagKey;
        var hasFired = localStorage.getItem(flagKey);
        if (!hasFired) {
            localStorage.setItem(flagKey, knownVariant);
            RudderstackClient.exposure({
                flag_key: flagKey,
                variant: knownVariant,
            });
        }
    }, [RudderstackClient, knownVariant, experimentConfig.flagKey]);
    return knownVariant || AMPLITUDE_OFF_ENROLMENT;
}
